import { Controller } from '@hotwired/stimulus'

// I-UX-MAILED-04: the names of the files chosen in a hidden file input (its native text follows the browser's language).
export default class FileListController extends Controller<HTMLElement> {
  static override targets = ['list']

  declare readonly listTarget: HTMLUListElement

  show(event: Event): void {
    const input = event.currentTarget
    if (!(input instanceof HTMLInputElement)) return
    this.listTarget.replaceChildren(...[...(input.files ?? [])].map((file) => {
      const item = document.createElement('li')
      item.textContent = file.name
      return item
    }))
  }
}
